export { DSMobilePageHeader, PageHeaderWithSchema } from './MobilePageHeader.js';
